import React from "react";
import QuoteStepBase from '../../components/QuoteStepBase'
import ButtonContinue from "../../components/ButtonContinue";
import { IQuoteStepState, IDriverStepProps } from "../../components/interfaces";
import { IAppState } from "../../state/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS, RELATIONSHIP_TO_INSURED } from "../../AppConstants";
import Utilities from "../../classes/Utilities";
import { ListGroup, OverlayTrigger, Popover } from 'react-bootstrap'
import { IListOption, IDriver, IQuoteApiClient, ILOBApiClient, IPaths } from "../../classes/Domain";
import { IUpdateAdditionalDriverResult } from "../../classes/ExternalQuote";
import _ from "lodash";
import { Alert } from 'react-bootstrap';
import { validationUtils } from "../../validation/Validation";
import { ValidatableForm } from "../../components/ValidatableForm";
import AdditionalDriver from "../../components/AdditionalDriver";
import QuoteActions from "../../state/appActions";
import FullQuoteActions from "../../state/fullQuoteActions";


const driverOptions = [
    { label: "Add Driver", value: "ADD"},
    { label: "Exclude Driver", value: "EXCLUDE" }
];

const genderOptions = [
    { label: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.FEMALE, value: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.FEMALE },
    { label: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.MALE, value: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.MALE }
    //{ label: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.OTHER, value: QUOTE_QUESTIONS.ABOUT_YOU.GENDER.OTHER }
];

const maritalOptions = [
    { label: QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.SINGLE, value: QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.SINGLE },
    { label: QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.MARRIED, value: QUOTE_QUESTIONS.ABOUT_YOU.MARITAL_STATUS.MARRIED }
];

const licenseStatusOptions = [
    { label: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.ACTIVE, value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.ACTIVE },
    { label: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.LEARNERS_PERMIT, value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.LEARNERS_PERMIT },
    { label: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.ID_CARD, value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.ID_CARD },
    { label: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SUSPENDED, value: QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SUSPENDED }
];

const relationshipOptions = [
    //{ label: RELATIONSHIP_TO_INSURED.UNKNOWN, value: RELATIONSHIP_TO_INSURED.UNKNOWN },
    { label: RELATIONSHIP_TO_INSURED.SPOUSE, value: RELATIONSHIP_TO_INSURED.SPOUSE },
    { label: RELATIONSHIP_TO_INSURED.CHILD, value: RELATIONSHIP_TO_INSURED.CHILD },
    { label: RELATIONSHIP_TO_INSURED.SIBLING, value: RELATIONSHIP_TO_INSURED.SIBLING },
    { label: RELATIONSHIP_TO_INSURED.PARENT, value: RELATIONSHIP_TO_INSURED.PARENT },
    //{ label: RELATIONSHIP_TO_INSURED.RELATIVE_OTHER, value: "RelativeOther" },
    { label: RELATIONSHIP_TO_INSURED.SIGNIFICANT_OTHER, value: "SignificantOther" },
    //{ label: RELATIONSHIP_TO_INSURED.DOMESTIC_PARTNER, value: "DomesticPartner" },
    //{ label: RELATIONSHIP_TO_INSURED.EMPLOYEE, value: RELATIONSHIP_TO_INSURED.EMPLOYEE },
    { label: RELATIONSHIP_TO_INSURED.NON_RELATIVE_OTHER, value: "NonRelativeOther" }
];

const renderTooltip = (props: any) => {
    return <Popover id="UNDISCOVEREDDRIVERSID" className="coverage-tooltip" {...props}>
        <Popover.Title as="h3">UNDISCOVERED DRIVERS</Popover.Title>
        <Popover.Content>
            These names are identified through industry reports (such as A-Plus) that show individuals potentially associated with your household or driving history.<br/>
            Please confirm whether each person should be included or excluded from your policy.<br/>
            <b>Excluded drivers are not covered under your policy and cannot operate your vehicles.</b>
        </Popover.Content>
    </Popover>;
};

interface ILooseObject {
    [key: string]: any
}

interface IState extends IQuoteStepState {
    showMessage: boolean,
    driverSelections: ILooseObject,
    additionalDrivers: Array<IDriver>,
    updateResult: IUpdateAdditionalDriverResult | null,
}

interface IProps extends IDriverStepProps {
    quoteId: number,
    paymentPlanCode: number,
    additionalDrivers: Array<IDriver>,
    updateAppStateAdditionalDrivers: (quoteId: number, paymentPlanCode: number, additionalDrivers: Array<IDriver>) => Promise<any>,
    reloadQuotePaymentInfo: (quoteId: number, quoteRerated: boolean) => Promise<any>,
    reRateQuote: (quoteId: number, paymentPlanCode: number) => Promise<any>,
    updateAppStateViolations: (quoteId: number) => Promise<any>,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths;
}

class AdditionalDrivers extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.getListSelectOption = this.getListSelectOption.bind(this);
        this.onDriverStatusChange = this.onDriverStatusChange.bind(this);
        this.onDriverDataChange = this.onDriverDataChange.bind(this);

        this.state = {
            showMessage: false,
            driverSelections: {},
            additionalDrivers: [],
            updatingStore: false,
            updateResult: null,
            errors: null
        }
    }

    componentDidMount() {
        this.props.reportCurrentStep();

        this.setState({ ...this.state, updatingStore: false, errors: null });

        validationUtils.subscribeToValidationFailure(FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure(FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const additionalDrivers = nextProps.additionalDrivers;
            nextProps.meta.propsSource = "";

            if (null === additionalDrivers) return prevState;

            return {
                ...prevState,
                additionalDrivers: additionalDrivers,
                driverSelections: {}
            };
        }

        return prevState;
    }

    next() {
        this.setState({ updatingStore: true }, () => {
            this.props.updateAppStateAdditionalDrivers(this.props.quoteId, this.props.paymentPlanCode, this.state.additionalDrivers)
                .then((response) => {
                    this.setState({ updateResult: response.data }, () => {
                        if (this.state.updateResult?.isSuccess)
                        {
                            this.props.updateAppStateViolations(this.props.quoteId)
                                .then((verisk) => {
                                    if (!verisk.data.hasErrors) {
                                        if (verisk.data.additionalDriversWasAdded) {
                                            this.setState({ ...this.state, errors: null, showMessage: true, updatingStore: false });
                                        }
                                        else if (verisk.data.hasViolationData) {
                                            this.props.history.push(Utilities.formatUrl(this.props.PATHS.FQ_VIOLATIONS, ""));
                                        }
                                        else {
                                            if (this.state.updateResult?.isRerated) {
                                                this.props.reloadQuotePaymentInfo(this.props.quoteId, true)
                                                    .then(() => {
                                                        this.setState({ ...this.state, updatingStore: false }, () => this.props.history.push(this.props.PATHS.FQ_POLICY_DETAILS));
                                                    }, () => this.stopUpdate());
                                            }
                                            else {
                                                this.props.reRateQuote(this.props.quoteId, this.props.paymentPlanCode)
                                                    .then(() => {
                                                        this.setState({ ...this.state, updatingStore: false }, () => this.props.history.push(this.props.PATHS.FQ_POLICY_DETAILS));
                                                });
                                            }
                                        }
                                    }
                                    else {
                                        this.setState({ ...this.state, errors: verisk.data.errors, updatingStore: false });
                                    }
                                });
                        }
                        else {
                            this.stopUpdate();
                        }
                    });
            }, () => this.stopUpdate());
        });
    }

    stopUpdate() {
        this.setState({ ...this.state, updatingStore: false });
    }

    getListSelectOption(driverIndex: number, options: Array<IListOption>, property: string, value: string = "") {
        const key = driverIndex + '_' + property;
        const selection = this.state.driverSelections[key]?.hasOwnProperty(driverIndex)
            ? this.state.driverSelections[key][driverIndex]
            : value === ""
                ? null
                : value;

        if (null === selection) return null;

        for (var i = 0; i < options.length; i++) {
            if (selection === options[i].value) return options[i];
        }

        return null;
    }

    onDriverStatusChange(driver: IDriver, driverIndex: number, option: IListOption | null)
    {
        if (!option || option.value === "") return;

        const isExcluded = option.value === "EXCLUDE";

        this.onDriverDataChange(isExcluded, driver, driverIndex, "isExcluded");
    }

    onDriverDataChange(value: any, driver: IDriver, driverIndex: number, property: string)
    {
        var additionalDrivers = [...this.state.additionalDrivers];

        var additionalDriver = additionalDrivers[driverIndex];

        if (additionalDriver && additionalDriver.id === driver.id) {
            additionalDriver[property] = value;
        }

        this.setState({ ...this.state, additionalDrivers });
    }

    render() {
        return (
            <QuoteStep id="additionalDrivers" className="">
                    <div className="titleArea">
                        <h5>
                            <span>
                                Undiscovered Drivers&nbsp;
                                <OverlayTrigger
                                    key={Utilities.uniqueId()}
                                    trigger={["hover", "click"]}
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={(props) => renderTooltip(props)}>
                                    <i className="fas fa-info-circle"></i>
                                </OverlayTrigger>
                            </span>
                        </h5>
                    </div>
                    <p className="info">We found these individuals through industry reports. Please review and confirm each driver.</p>
                   {
                    this.state.showMessage
                        ?
                        <div>
                            <Alert variant={"warning"}>
                                <p><strong className="text-uppercase">New Undiscovered Drivers Were Added!</strong></p>
                                <ul>
                                    <p>Please check drivers below</p>
                                </ul>
                            </Alert>
                        </div>
                        :
                        null
                    }

                    {
                        this.state.updateResult && this.state.updateResult.errors?.length > 0
                            ? <Alert variant={"danger"}>
                                <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                                <p>Please review errors below</p>
                                <ul>
                                    {
                                        this.state.updateResult.errors.map((error) => (
                                            <li key={Utilities.uniqueId()}>
                                                <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: error }}></p>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </Alert>
                            : null
                    }

                <div className="rate-result">
                    {this.state.additionalDrivers && this.state.additionalDrivers.length > 0
                            ?
                        <ValidatableForm hasErrors={null != this.state.errors}>
                            <ListGroup variant="flush">
                                {
                                    this.state.additionalDrivers.map((driverData: IDriver, driverIndex) => (
                                        <AdditionalDriver
                                            key={"additionalDriver_" + driverData.id}
                                            driverStatus={driverData.isExcluded ? "EXCLUDE" : "ADD"}
                                            licenseStatus={driverData.currentLicenseStatus}
                                            gender={driverData.gender}
                                            maritalStatus={driverData.maritalStatus}
                                            relationshipLevel={driverData.relationshipLevel}
                                            disabled={this.state.updatingStore ?? false}
                                            driverOptions={driverOptions}
                                            genderOptions={genderOptions}
                                            maritalOptions={maritalOptions}
                                            licenseStatusOptions={licenseStatusOptions}
                                            relationshipOptions={relationshipOptions}
                                            driverIndex={driverIndex}
                                            additionalDriver={driverData}
                                            getListSelectOption={this.getListSelectOption}
                                            onDriverStatusChange={this.onDriverStatusChange}
                                            onDriverDataChange={this.onDriverDataChange}
                                        />
                                    ))
                                }
                            </ListGroup>
                        </ValidatableForm>
                            :
                            <div>
                                <Alert variant={"warning"}>
                                <h5 className="text-center">Already Processed</h5>
                                </Alert>
                            </div>
                        }
                    </div>

                    <div className="btnContainer">
                        <ButtonContinue
                            label="Continue"
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next}
                    />
                    </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IProps) => {
    return {
        quoteId: state.externalQuote?.rtrQuoteId,
        paymentPlanCode: state.externalQuote?.paymentPlanCode,
        additionalDrivers: state.externalQuote?.mvrResult?.drivers.filter(x => x.fromVerisk),
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS)),
        updateAppStateAdditionalDrivers: (quoteId: number, paymentPlanCode: number, additionalDrivers: Array<IDriver>) => dispatch(fullQuoteActions.updateAdditionalDrivers(quoteId, paymentPlanCode, additionalDrivers)),
        reloadQuotePaymentInfo: (quoteId: number, quoteRerated: boolean) => dispatch(fullQuoteActions.reloadQuotePaymentInfo(quoteId, quoteRerated)),
        reRateQuote: (quoteId: number, paymentPlanCode: number) => dispatch(fullQuoteActions.reRateQuote(quoteId, paymentPlanCode, false)),
        updateAppStateViolations: (quoteId: number) => dispatch(fullQuoteActions.getViolations(quoteId))
    };
};

export default connect(mapProps, mapDispatch)(AdditionalDrivers);
